/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const conversationFeaturesCommonMessages = defineMessages({
    addingFeatureRunningTitle: {
        id: 'luis.features.addingFeatureRunningTitle',
        defaultMessage: 'Adding feature...'
    },
    addingFeatureFailureTitle: {
        id: 'luis.features.addingFeatureFailureTitle',
        defaultMessage: 'Failed to add feature'
    },
    addingFeatureSuccessTitle: {
        id: 'luis.features.addingFeatureSuccessTitle',
        defaultMessage: 'Feature added successfully'
    },
    removingFeatureRunningTitle: {
        id: 'luis.features.removingFeature',
        defaultMessage: 'Removing feature...'
    },
    removingFeatureFailureTitle: {
        id: 'luis.features.removingFeatureFailureTitle',
        defaultMessage: 'Failed to remove feature'
    },
    removingFeatureSuccessTitle: {
        id: 'luis.features.removingFeatureSuccessTitle',
        defaultMessage: 'Feature removed successfully'
    }
});
